export const compareArrays = (a, b) => JSON.stringify(a) === JSON.stringify(b);
